module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1087.5272588b.png";